import React, { useState, useEffect } from 'react';
import { FaBullhorn } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import FormattedTime from '../Common/FormattedTime.jsx';
import './AnnouncementCard.css';
import { getAllAnnouncement } from '../../api/announcementsAPI';

const AnnouncementCard = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await getAllAnnouncement();
        
        // Get the latest 3 announcements
        const latestAnnouncements = response.data
          .sort((a, b) => new Date(b.time_to_send) - new Date(a.time_to_send))
          .slice(0, 3);
        
        setAnnouncements(latestAnnouncements);
      } catch (err) {
        console.error("Error fetching announcements:", err);
        setError("Failed to load announcements");
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncements();
  }, []);

  const handleViewAll = () => {
    navigate('/announcements');
  };

  if (loading) return <div className="announcement-card">Loading announcements...</div>;
  if (error) return <div className="announcement-card">{error}</div>;

  return (
    <div className="announcement-card">
      <div className="announcement-header">
        <div className="announcement-icon">
          <FaBullhorn />
        </div>
        <h2>Announcements</h2>
      </div>

      {announcements.length === 0 ? (
        <p className="no-announcements">No announcements yet</p>
      ) : (
        <div className="announcements-list">
          {announcements.map((announcement) => (
            <div key={announcement.announcement_id} className="announcement-item">
              <div className="announcement-content">
                <h3>{announcement.header}</h3>
                <span className="announcement-time">{<FormattedTime datetime={announcement.time_to_send} />}</span>
              </div>
              <span className="committee-badge">
                {announcement.committee?.committee_name || 'General'}
              </span>
            </div>
          ))}
        </div>
      )}

      <button className="view-all-btn" onClick={handleViewAll}>
        View All Announcements
      </button>
    </div>
  );
};

export default AnnouncementCard;
